export default "__VITE_ASSET__B47q5vdC__"